/* Pastel Coffee P2 Task 3: mobile sticky add-to-cart bar.
   Shows once the main buy buttons are scrolled past (above the viewport).
   The bar's button submits the main product form via its `form` attribute,
   so Dawn's product-form.js AJAX flow (cart drawer/notification) is reused
   untouched. Label, disabled state and price are mirrored from the main
   button/price elements so variant changes stay in sync without touching
   Dawn's variant-picker logic.

   Visibility uses a passive scroll listener throttled with rAF instead of
   an IntersectionObserver: an IO fires no entry when a fast scroll jumps
   the button across the whole viewport (below → above is "not intersecting"
   both times), leaving the bar stuck hidden. */

if (!customElements.get('sticky-add-to-cart')) {
  customElements.define(
    'sticky-add-to-cart',
    class StickyAddToCart extends HTMLElement {
      connectedCallback() {
        this.sectionId = this.dataset.sectionId;
        this.button = this.querySelector('.sticky-atc__button');
        this.buttonLabel = this.button ? this.button.querySelector('span') : null;
        this.priceEl = this.querySelector('.sticky-atc__price');

        if (!this.getMainButton() || !this.button) return;

        this.removeAttribute('hidden');

        this.onScroll = () => {
          if (this.scrollTicking) return;
          this.scrollTicking = true;
          requestAnimationFrame(() => {
            this.scrollTicking = false;
            const mainButton = this.getMainButton();
            if (!mainButton) return;
            const scrolledPast = mainButton.getBoundingClientRect().bottom < 0;
            this.classList.toggle('sticky-atc--visible', scrolledPast);
          });
        };
        window.addEventListener('scroll', this.onScroll, { passive: true });
        this.onScroll();

        const productInfo = document.querySelector(`product-info[data-section="${this.sectionId}"]`);
        if (productInfo) {
          this.syncObserver = new MutationObserver(() => this.sync());
          this.syncObserver.observe(productInfo, {
            subtree: true,
            childList: true,
            characterData: true,
            attributes: true,
            attributeFilter: ['disabled', 'class'],
          });
        }
      }

      disconnectedCallback() {
        if (this.onScroll) window.removeEventListener('scroll', this.onScroll);
        if (this.syncObserver) this.syncObserver.disconnect();
      }

      getMainButton() {
        return document.getElementById(`ProductSubmitButton-${this.sectionId}`);
      }

      sync() {
        const mainButton = this.getMainButton();
        if (mainButton) {
          this.button.disabled = mainButton.disabled;
          const label = mainButton.querySelector('span');
          if (label && this.buttonLabel) this.buttonLabel.textContent = label.textContent.trim();
        }
        const priceContainer = document.getElementById(`price-${this.sectionId}`);
        if (priceContainer && this.priceEl) {
          const price =
            priceContainer.querySelector('.price--on-sale .price__sale .price-item--sale') ||
            priceContainer.querySelector('.price__regular .price-item--regular');
          if (price) this.priceEl.textContent = price.textContent.trim();
        }
      }
    }
  );
}
